// FormFields.js

import React from "react";
import TextField from "@mui/material/TextField";

const FormFields = ({ formikSuper }) => {
  return (
    <>
      <TextField
        name="firstName"
        id="firstName"
        label="firstName"
        value={formikSuper?.values?.firstName}
        onChange={formikSuper?.handleChange}
        error={
          formikSuper?.errors?.firstName && formikSuper?.touched?.firstName
        }
        helperText={
          formikSuper?.errors?.firstName &&
          formikSuper?.touched?.firstName &&
          formikSuper?.errors?.firstName
        }
        fullWidth
        variant="outlined"
        size="small"
      />
      <TextField
        name="lastName"
        id="lastName"
        label="lastName"
        value={formikSuper?.values?.lastName}
        onChange={formikSuper?.handleChange}
        error={formikSuper?.errors?.lastName && formikSuper?.touched?.lastName}
        helperText={
          formikSuper?.errors?.lastName &&
          formikSuper?.touched?.lastName &&
          formikSuper?.errors?.firstName
        }
        fullWidth
        variant="outlined"
        size="small"
      />
    </>
  );
};

export default FormFields;
